import { useTranslation } from 'react-i18next';

interface PlatformInstructionsPreviewProps {
  instructions: string | null;
}

export function PlatformInstructionsPreview({ instructions }: PlatformInstructionsPreviewProps) {
  const { t } = useTranslation('assistant');
  if (instructions === null) {
    return null;
  }
  return (
    <div className="rounded-xl bg-zoooffwhite border border-zooborder px-4 py-3">
      <p className="text-xs font-semibold text-zooindigo">
        {t('configuration.instructions.platformInstructionsLabel')}
      </p>
      <p className="text-xs text-zoomuted mt-1 whitespace-pre-line">{instructions}</p>
    </div>
  );
}
